var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.997,
    height: 12.997,
    viewBox: "0 0 12.997 12.997",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info-fill",
    transform: "translate(-2.362 -2.362)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11537",
    "data-name": "Path 11537",
    d: "M30.5,24A6.5,6.5,0,1,0,37,30.5,6.5,6.5,0,0,0,30.5,24Zm0,3a.75.75,0,1,1-.75.75A.75.75,0,0,1,30.5,27Zm.5,7h-.5a.5.5,0,0,1-.5-.5v-3a.5.5,0,0,1,0-1h.5a.5.5,0,0,1,.5.5v3a.5.5,0,1,1,0,1Z",
    transform: "translate(-21.64 -21.638)",
    fill: "#9a9a9a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoFill);
export default __webpack_public_path__ + "static/media/info-fill.c4ed453b.svg";
export { ForwardRef as ReactComponent };